import styled from "styled-components"
import 'swiper/css/scrollbar'
import {Button, Modal} from "antd"
import {useState} from "react"
import ContactForm from "../../../components/ContactForm"

const data = [
	{
		title: 'Мобильное приложение',
		image: '/assets/img/jpg/monitoring/store/mobile-app.jpg',
		options: [
			{title: 'Запись местоположения'},
			{title: 'Автоматический статус посещения'},
			{title: 'Низкий расход аккумулятора'},
			{title: 'Работа в фоновом режиме'},
			{title: 'Остановки и стоянки'}
		],
		rnis: false,
		price: 0
	},
	{
		title: 'Lite',
		image: '/assets/img/jpg/monitoring/store/lite.jpg',
		options: [
			{title: 'Скрытый монтаж', plus: true},
			{title: 'Автономная работа', plus: true},
			{title: 'Высокая точность', plus: true},
			{title: 'Контроль зажигания', plus: true},
			{title: 'До 10 Bluetooth датчиков', plus: true}
		],
		rnis: true,
		price: 990
	},
	{
		title: 'Portable',
		image: '/assets/img/jpg/monitoring/store/portable.jpg',
		options: [
			{title: 'Скрытый монтаж', plus: true},
			{title: 'Автономная работа', plus: true},
			{title: 'Высокая точность', plus: true},
			{title: 'Контроль зажигания', plus: true},
			{title: 'До 10 Bluetooth датчиков', plus: true}
		],
		rnis: true,
		price: 990
	},
	{
		title: 'CAN',
		image: '/assets/img/jpg/monitoring/store/can.jpg',
		options: [
			{title: '2 SIM карты', plus: true},
			{title: '1-Wire протокол', plus: true},
			{title: 'Пробег по одометру', plus: true},
			{title: 'Уровень топлива', plus: true},
			{title: 'Техническое состояние ТС', plus: true}
		],
		rnis: true,
		price: '1 990'
	}
]

const Trackers = () => {
	const [open, setOpen] = useState(false)

	return (
		<Container>
			{data.map((tracker, trackerIndex) => (
				<Tracker key={'t-' + trackerIndex}>
					<h3>{tracker.title}</h3>
					<Image>
						<img src={tracker.image} style={{height: 280}} alt={tracker.title}/>
					</Image>
					{tracker.rnis &&
						<RNIS>
							<img src="/assets/img/svg/rnis.svg" height={18} alt="RNIS"/>
							РНИС
						</RNIS>}
					{tracker.options.map((option, optionIndex) => (
						<div key={'o-' + optionIndex}>{option.title}</div>
					))}
					{tracker.price ?
						<Button color="default" onClick={() => setOpen(true)} variant="solid" size="large">
							Купить от {tracker.price}&#8201;₽
						</Button> : <Button color="default" size="large">
							Инструкция
						</Button>}
				</Tracker>
			))}
			<Modal width={660} style={{top: 20}} maskClosable={false} open={open} onCancel={() => setOpen(false)}
				   footer={null}>
				<ModalContent>
					<h2>Новый заказ</h2>
					<div>Мы свяжемся с вами в самое ближайшее время.</div>
					<ContactForm trackers onFinish={() => {
						setOpen(false)
					}}/>
				</ModalContent>
			</Modal>
		</Container>
	)
}

export default Trackers

const Container = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 3rem;
    row-gap: 3rem;
    max-width: 900px;

    @media (max-width: 1400px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 800px) {
        grid-template-columns: repeat(1, 1fr); // 1 колонка
    }
`

const Tracker = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 400px;
    padding: 1.5rem;
    border: solid 1px #d6d6d6;
    border-radius: 0.75rem;
    gap: 1rem;
`

const Image = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
`
const RNIS = styled.div`
    display: flex;
    align-self: flex-start;
    align-items: center;
    gap: 0.27rem;
    padding: 0.33rem 0.44rem;
    background-color: #d9232e;
    border-radius: 5px;
    color: #ffffff;
    font-weight: 500;
    font-size: 0.88rem;
`
const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    padding: 1.11rem;
    gap: 1.33rem;
`

/*
import styled from "styled-components"
import 'swiper/css/scrollbar'
import Icon from "../../../components/Icon/Icon"
import {faLocationArrow, faPlus} from "@fortawesome/pro-light-svg-icons"
import {Button, Modal} from "antd"
import {useState} from "react"
import ContactForm from "../../../components/ContactForm"

const Trackers = () => {

	const [open, setOpen] = useState(false)

	const data = [
		{
			title: 'Мобильное приложение',
			image: '/assets/img/jpg/monitoring/store/mobile-app.jpg',
			options: [
				{title: 'Запись местоположения'},
				{title: 'Автоматический статус посещения'},
				{title: 'Низкий расход аккумулятора'},
				{title: 'Работа в фоновом режиме'},
				{title: 'Остановки и стоянки'}
			],
			rnis: false,
			price: 0
		},
		{
			title: 'Lite',
			image: '/assets/img/jpg/monitoring/store/lite.jpg',
			options: [
				{title: 'Скрытый монтаж', plus: true},
				{title: 'Автономная работа', plus: true},
				{title: 'Высокая точность', plus: true},
				{title: 'Контроль зажигания', plus: true},
				{title: 'До 10 Bluetooth датчиков', plus: true}
			],
			rnis: true,
			price: 990
		},
		{
			title: 'CAN',
			image: '/assets/img/jpg/monitoring/store/can.jpg',
			options: [
				{title: '2 SIM карты', plus: true},
				{title: '1-Wire протокол', plus: true},
				{title: 'Пробег по одометру', plus: true},
				{title: 'Уровень топлива', plus: true},
				{title: 'Техническое состояние ТС', plus: true}
			],
			rnis: true,
			price: '1 990'
		}
	]

	return (
		<>
			<h2>Выбор трекера</h2>
			<Wrapper>
				<TrackersWrapper>
					{data.map((tracker, trackerIndex) => (
						<Tracker key={'tracker' + trackerIndex} isFirst={trackerIndex === 0}>
							<Title>
								{tracker.title}
							</Title>
							<Image>
								<img src={tracker.image} style={{height: 300}} alt={tracker.title}/>
							</Image>
							{tracker.rnis &&
								<RNIS>
									<img src="/assets/img/svg/rnis.svg" height={18} alt="RNIS"/>
									РНИС
								</RNIS>}
							<Options>
								{tracker.options.map((option, optionIndex) => (
									<Option key={'option' + optionIndex}>
										<OptionIcon>
											<Icon name={option.plus ? faPlus : faLocationArrow} size={22}
												  color="#713fdb"/>
										</OptionIcon>
										<Description>
											{option.title}
										</Description>
									</Option>
								))}
							</Options>

							{tracker.price ?
								<Button color="default" onClick={() => setOpen(true)} variant="solid" size="large">
									Купить от {tracker.price}&#8201;₽
								</Button> : <Button color="default" size="large">
									Инструкция
								</Button>}
						</Tracker>
					))}
				</TrackersWrapper>
				<Retranslation>
					Цены действительны при подключении по контракту на 12 месяцев (абонплата от 290₽/мес за ТС). Без
					контракта: комплект Lite — 2990₽, CAN-серия — 3990₽.
				</Retranslation>
			</Wrapper>

		</>
	)
}

export default Trackers


const Wrapper = styled.div`
    display: flex;
    flex-direction: column;

    // При ширине экрана меньше 350px меняем поведение внутри:
    @media (max-width: 350px) {
        // TrackersWrapper переходит в колонку
        > div {
            flex-direction: column;
        }
    }
`

const TrackersWrapper = styled.div`
    display: flex;
    flex: 1;

    // при ширине >350px - строки, при меньше - колонки
    @media (max-width: 350px) {
        flex-direction: column;
    }
`

const Tracker = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 1 33.3333%;
    padding: 0 24px;

    // Бордер слева, кроме первого
    border-left: ${({isFirst}) => (isFirst ? "none" : "1px solid #d6d6d6")};

    // При сужении <350px убираем бордер слева и делаем верхний
    @media (max-width: 350px) {
        width: 100%;
        padding: 16px 0;
        border-left: none;
        border-top: 1px solid #d6d6d6;

        &:first-child {
            border-top: none;
        }
    }
`

const Title = styled.div`
    font-size: 30px;
    white-space: nowrap; // Запрет переносов заголовков
`

const Image = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
`

const RNIS = styled.div`
    display: flex;
    align-self: flex-start;
    align-items: center;
    gap: 5px;
    padding: 6px 8px;
    background-color: #d9232e;
    border-radius: 5px;
    color: #ffffff;
    font-weight: 500;
    font-size: 16px;
`

const Options = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    gap: 20px;
    padding-bottom: 40px;
`

const Option = styled.div`
    display: flex;
    gap: 10px;
`

const OptionIcon = styled.div``

const Description = styled.div``

const Retranslation = styled.div`
    font-size: 14px;
    margin-top: 60px;
    font-style: italic;
`

const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px;
    gap: 24px;
`

const ModalTitle = styled.div`
    font-size: 34px;
    line-height: 34px;
`
*/
